export default {
    apiHost: 'https://api-scrm.miniso.com',
    weWorkPluginHost: 'https://work-scrm.miniso.com',
}
